import { computed, unref, type MaybeRef } from "vue";
import {
  type AlbumMediaPostType,
  getMaxMediaCount,
  getMediaSectionLabel,
  getUploadMediaLabel,
  isReelPostType,
  isStoryPostType,
  isVideoOnlyUploadForPostType,
  isVideoUploadAllowedForPostType,
  validateFileBeforeUpload,
} from "@logic/AtlasSchedulingValidation";

export function usePostTypeMediaRules(postType: MaybeRef<AlbumMediaPostType>) {
  const resolvedPostType = computed(() => unref(postType));

  const isReelPost = computed(() => isReelPostType(resolvedPostType.value));
  const isStoryPost = computed(() => isStoryPostType(resolvedPostType.value));
  const maxMediaCount = computed(() => getMaxMediaCount(resolvedPostType.value));
  const isVideoUploadAllowed = computed(() => isVideoUploadAllowedForPostType(resolvedPostType.value));
  const isVideoOnlyUploadAllowed = computed(() => isVideoOnlyUploadForPostType(resolvedPostType.value));
  const uploadMediaLabel = computed(() => getUploadMediaLabel(resolvedPostType.value));
  const mediaSectionLabel = computed(() => getMediaSectionLabel(resolvedPostType.value));
  const videoOnlyForAlbumPicker = computed(() => isReelPost.value);
  const showAlbumPhotoAndVideoCount = computed(() => isReelPost.value || isStoryPost.value);

  const beforeFileUploadValidate = computed(() => {
    if (!isReelPost.value && !isStoryPost.value) {
      return null;
    }
    const type = resolvedPostType.value;
    return (file: File) => validateFileBeforeUpload(type, file);
  });

  return {
    isReelPost,
    isStoryPost,
    maxMediaCount,
    isVideoUploadAllowed,
    isVideoOnlyUploadAllowed,
    beforeFileUploadValidate,
    uploadMediaLabel,
    mediaSectionLabel,
    videoOnlyForAlbumPicker,
    showAlbumPhotoAndVideoCount,
  };
}
